// The `Modal` component renders its content only when it's open (`show=true`).
// To avoid triggering API request when modals are not displayed, the modal content is isolated
// in a separated component.
import {
  ModalBody,
  ModalContent,
  ModalContentSize,
  ModalHeader,
  ModalTitle,
  useCloseModal
} from "@quortex/front-common"
import { QoEProviderForm } from "@/pages/ContentSteering/Settings/QoEProviderForm"

const AddSegmentModalContent = () => {
  const closeModal = useCloseModal()

  const onClose = () => {
    closeModal()
  }

  return (
    <ModalContent data-testid="add-segment-modal-content" size={ModalContentSize.S}>
      <ModalHeader onClose={onClose}>
        <ModalTitle>Connect QoE provider</ModalTitle>
      </ModalHeader>

      <ModalBody>
        <QoEProviderForm />
      </ModalBody>
    </ModalContent>
  )
}

export default AddSegmentModalContent
